<svg viewBox="0 0 1509 110" preserveAspectRatio="none" fill="none" width="100%" xmlns="http://www.w3.org/2000/svg">
  <path style="visibility:hidden" [attr.d]="bigPath"
    [attr.fill]="'url('+loca.pathname+'#'+localtionName+'paint0_linear'" />
  <foreignObject style="visibility:hidden" x="0" y="0" width="1509" height="110" transform="">
    <ng-content #content></ng-content>
  </foreignObject>
  <clipPath id="myClip">
    <path style="visibility:hidden" id="curve" [attr.d]="bigPath" />
  </clipPath>
    <image preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/xlink" [attr.xlink:href]="image" x="80%" y="10"
      height="300" width="300" [attr.clip-path]="'url('+loca.pathname+'#myClip)'" />
  <defs>
    <linearGradient [attr.id]="localtionName+'paint0_linear'" x1="-96" y1="61" x2="1739" y2="100"
      gradientUnits="userSpaceOnUse">
      <stop offset="0.1" stop-color="#4FAF97" />
      <stop offset="0.5" stop-color="#9FC566" />
      <stop offset="0.8" stop-color="#4FAF97" />
    </linearGradient>
  </defs>
</svg>
